import { useGetIdentity } from "ra-core";
import { Link } from "react-router";
import { Eye, Pencil } from "lucide-react";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DeleteButton } from "@/components/admin/delete-button";
import { List } from "@/components/admin/list";
import { Button } from "@/components/ui/button";

import { TopToolbar } from "../layout/TopToolbar";
import type { Group } from "../types";

/** Link to the prospects list pre-filtered to one list (group). */
const viewListPath = (record: Group) =>
  `/prospects?filter=${encodeURIComponent(JSON.stringify({ group_id: record.id }))}`;

export const GroupList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;

  return (
    <List
      title="Lists"
      actions={
        <TopToolbar>
          <CreateButton />
        </TopToolbar>
      }
      perPage={50}
      sort={{ field: "name", order: "ASC" }}
    >
      <DataTable rowClassName={() => "cursor-pointer"}>
        <DataTable.Col
          label="Color"
          render={(record: Group) => (
            <span
              className="inline-block w-4 h-4 rounded-full border"
              style={{ backgroundColor: record.color }}
            />
          )}
        />
        <DataTable.Col source="name" label="Name" />
        <DataTable.Col
          label=""
          render={(record: Group) => (
            <div
              className="flex justify-end gap-2"
              onClick={(e) => e.stopPropagation()}
            >
              <Button asChild variant="outline" size="sm">
                <Link
                  to={viewListPath(record)}
                  title="View the prospects on this list"
                >
                  <Eye className="size-4" /> View
                </Link>
              </Button>
              <Button asChild variant="outline" size="sm">
                <Link to={`/groups/${record.id}`} title="Rename or recolor this list">
                  <Pencil className="size-4" /> Edit
                </Link>
              </Button>
              <DeleteButton size="sm" label="Remove" />
            </div>
          )}
        />
      </DataTable>
    </List>
  );
};
